const Backbone = require('backbone');
const Nunjucks = require('nunjucks');
const $ = require('jquery');

var env = new Nunjucks.Environment(new Nunjucks.WebLoader('./views',{useCache:true}));

var $base = $('base').clone();

const MetaTagsView = Backbone.View.extend({
	el: 'head',
	initialize: function(config) {
		var that = this;
		that.template = 'includes/meta-tags.twig';
		that.render();
	},
	render: function() {
		var that = this;
		
		var data = {};
		try {
			var $head = $('<head></head>');
			$head.html(env.render(that.template, data));
			$head.prepend($base);
			that.$el.html($head.html());
		} catch (e) {
			console.log(e);
		}
	}
});

//new MetaTagsView();


//////////////////
// WEBPACK FOOTER
// ./js/views/meta-tags.js
// module id = 18
// module chunks = 0